import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tariff-pricing-constraint.reducer';

export const TariffPricingConstraintDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tariffPricingConstraintEntity = useAppSelector(state => state.tariffPricingConstraint.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tariffPricingConstraintDetailsHeading">
          <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.detail.title">
            TariffPricingConstraint
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tariffPricingConstraintEntity.id}</dd>
          <dt>
            <span id="minPrice">
              <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.minPrice">Min Price</Translate>
            </span>
          </dt>
          <dd>{tariffPricingConstraintEntity.minPrice}</dd>
          <dt>
            <span id="maxPrice">
              <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.maxPrice">Max Price</Translate>
            </span>
          </dt>
          <dd>{tariffPricingConstraintEntity.maxPrice}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {tariffPricingConstraintEntity.effectiveDate ? (
              <TextFormat
                value={tariffPricingConstraintEntity.effectiveDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.tariff">Tariff</Translate>
          </dt>
          <dd>{tariffPricingConstraintEntity.tariff ? tariffPricingConstraintEntity.tariff.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tariff-pricing-constraint" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/tariff-pricing-constraint/${tariffPricingConstraintEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TariffPricingConstraintDetail;
